import React, { useState } from "react";

import "./artifacts.css";

const RESPONSIBILITIES = [
	"Reviews AI outputs against a written definition of correct behavior",
	"Signs off before any model or agent reaches production",
	"Owns the test set and updates it when the system or data changes",
	"Reports independently, not to the team that built the system",
	"Has authority to block a release",
];

const TEVVTemplate = () => {
	const [owner, setOwner] = useState("");
	const [cadence, setCadence] = useState("Every release, plus monthly");
	const [copied, setCopied] = useState(false);

	const template = `MINIMUM VIABLE AI REVIEW ROLE (TEVV)

Named owner: ${owner || "[assign a person, not a team]"}
Review cadence: ${cadence || "[define a cadence]"}

Responsibilities:
${RESPONSIBILITIES.map((r) => `- ${r}`).join("\n")}

Rule: no AI system ships without this person's sign-off.`;

	const copy = () => {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(template).then(() => {
				setCopied(true);
				setTimeout(() => setCopied(false), 2000);
			});
		}
	};

	return (
		<div className="artifact-card">
			<div className="artifact-kicker">Interactive · Free template</div>
			<div className="artifact-title">
				Minimum Viable Review Role
			</div>
			<div className="artifact-intro">
				NIST assumes an independent reviewer exists. Here is the smallest
				version you can actually staff. Fill in the two blanks and copy
				it into your team doc.
			</div>

			<div className="artifact-input-row">
				<span className="artifact-label">Named owner</span>
				<input
					className="artifact-input"
					style={{ width: "200px", textAlign: "left" }}
					type="text"
					placeholder="A person"
					value={owner}
					onChange={(e) => setOwner(e.target.value)}
				/>
			</div>
			<div className="artifact-input-row">
				<span className="artifact-label">Review cadence</span>
				<input
					className="artifact-input"
					style={{ width: "200px", textAlign: "left" }}
					type="text"
					value={cadence}
					onChange={(e) => setCadence(e.target.value)}
				/>
			</div>

			<div className="artifact-template-out">{template}</div>

			<button className="artifact-btn" type="button" onClick={copy}>
				{copied ? "Copied" : "Copy template"}
			</button>
		</div>
	);
};

export default TEVVTemplate;
